"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContentToolDialog = void 0;
const sds_1 = require("@squiz/sds");
const createDialogProps_1 = require("../../utils/createDialogProps/createDialogProps");
const useStore_1 = require("../useStore");
const useContentToolDialog = (content, contentTool, onInsertAfter, onReplace) => {
    const { updateActiveDialog } = (0, sds_1.useDialogStore)();
    const { resetStore } = (0, useStore_1.useStore)();
    const dialogProps = (0, createDialogProps_1.createDialogProps)(content, contentTool, onInsertAfter, onReplace);
    dialogProps.stateHandler = sds_1.useDialogStore;
    return {
        dialogProps: dialogProps,
        open: () => {
            resetStore();
            updateActiveDialog(dialogProps);
        },
    };
};
exports.useContentToolDialog = useContentToolDialog;
